import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/Auth.css';
import '../assets/styles/PrivacyConsent.css';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [showPrivacyDetails, setShowPrivacyDetails] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    if (!privacyAccepted) {
      setError('You must accept the Privacy Policy and Terms of Service to continue.');
      return false;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return false;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters long.');
      return false;
    }
    return true;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    setIsLoading(true);
    try {
      await axios.post('https://api.startupdriver.co/api/auth/register', { 
        email, 
        password,
        privacyAccepted: true // Save that user has accepted the privacy policy
      });
      setSuccess('Registration successful! Redirecting to login...');
      setError('');
      
      setTimeout(() => {
        setIsLoading(false);
        navigate('/');
      }, 2000);
    } catch (err) {
      setError('Registration failed. Email may already be in use.');
      setSuccess('');
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Create Account</h2>
        {success && <p className="success">{success}</p>}
        {error && <p className="error">{error}</p>}
        
        <form onSubmit={handleRegister}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Create a password"
              required
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your password"
              required
              autoComplete="new-password"
            />
          </div>
          
          <div className="compact-privacy-consent">
            <div className="privacy-header" onClick={() => setShowPrivacyDetails(!showPrivacyDetails)}>
              <div className="privacy-title">
                <span className="privacy-consent-icon">{showPrivacyDetails ? '▼' : '▶'}</span>
                Privacy Policy & Terms of Service
              </div>
              <div className="privacy-toggle">
                {showPrivacyDetails ? 'Hide Details' : 'View Details'}
              </div>
            </div>
            
            {showPrivacyDetails && (
              <div className="privacy-details">
                <div className="privacy-content">
                  <h4>1. Introduction</h4>
                  <p>Welcome to the Investor Startup Driver platform. By using our Platform, you agree to all terms and conditions of this Agreement.</p>
                  
                  <h4>2. Data Collection and Use</h4>
                  <p>We collect registration information, form data, usage data, and device information to provide our services.</p>
                  
                  <h4>3. User Rights and Responsibilities</h4>
                  <p>You have the right to access, correct, or delete your data. You agree to comply with laws and respect others' rights.</p>
                  
                  <h4>4. Content and Intellectual Property</h4>
                  <p>You retain IP rights to your content but grant us usage rights. Platform content belongs to us or licensors.</p>
                  
                  <h4>5. Disclaimers and Liability</h4>
                  <p>The Platform is provided "as is" without warranties. We're not liable for indirect or consequential damages.</p>
                  
                  <p className="read-more-link"><a href="#" onClick={(e) => {e.preventDefault(); window.open('/register-privacy-policy', '_blank');}}>Read the full Privacy Policy and Terms of Service</a></p>
                </div>
              </div>
            )}
            
            <div className="privacy-checkbox">
              <label>
                <input 
                  type="checkbox" 
                  checked={privacyAccepted}
                  onChange={(e) => setPrivacyAccepted(e.target.checked)}
                  required
                />
                I have read and agree to the Privacy Policy and Terms of Service
              </label>
            </div>
          </div>
          
          <button type="submit" className="auth-btn" disabled={isLoading}>
            {isLoading ? 'Creating Account...' : 'Register'}
          </button>
        </form>
        
        <p className="switch-text">
          Already have an account?{' '}
          <span className="switch-link" onClick={() => navigate('/')}>
            Login here
          </span>
        </p>
      </div>
    </div>
  );
};

export default Register;